// © 2026 Camp Promethean, LLC. All Rights Reserved.
// Typed subscription funnel events. Local-only for v1 (console + in-memory
// buffer); swap `emit` for a real provider (PostHog, GA) without touching
// call sites. Spec: docs/upgrade-downgrade-flow-spec.md §8

export type SubscriptionEvent =
  | "plan_change_initiated"
  | "checkout_redirect"
  | "plan_upgrade_success"
  | "plan_downgrade_success"
  | "plan_downgrade_scheduled"
  | "plan_change_kept"
  | "plan_change_error"
  | "success_page_viewed"
  | "success_page_activation_delayed"
  | "success_cta_clicked"
  | "upgrade_intent_captured"
  | "upgrade_intent_resumed";

export interface SubscriptionEventPayload {
  event: SubscriptionEvent;
  timestamp: string;
  details: Record<string, unknown>;
}

const buffer: SubscriptionEventPayload[] = [];
const BUFFER_LIMIT = 100;

function emit(payload: SubscriptionEventPayload) {
  // v1 sink: console. Replace with provider.capture(payload.event, ...) later.
  console.log(`[Subscription ${payload.event}]`, {
    timestamp: payload.timestamp,
    ...payload.details,
  });
}

export function trackSubscriptionEvent(
  event: SubscriptionEvent,
  details: Record<string, unknown> = {},
) {
  const payload: SubscriptionEventPayload = {
    event,
    timestamp: new Date().toISOString(),
    details,
  };
  buffer.push(payload);
  if (buffer.length > BUFFER_LIMIT) buffer.shift();
  emit(payload);
}

/** Recent events, for debugging or a future flush-to-provider. */
export function getSubscriptionEventBuffer(): readonly SubscriptionEventPayload[] {
  return buffer;
}
